import {
  CALENDAR_EVENTS_FETCH_START,
  CALENDAR_EVENTS_FETCH_FAIL,
  CALENDAR_EVENTS_FETCH_SUCCESS,
} from '../constants/actionTypes'
import eventsProvider from '../providers/events'

const eventsActions = {
  fetchEvents: function (params) {
    return {
      types: [
        CALENDAR_EVENTS_FETCH_START,
        CALENDAR_EVENTS_FETCH_SUCCESS,
        CALENDAR_EVENTS_FETCH_FAIL,
      ],
      promise: eventsProvider.fetchEvents(params),
    }
  },
}

export default eventsActions
